module.exports = __webpack_public_path__ + "static/Lato-MediumItalic-aa1a75124661b40a6770dc0d8274ddaa.woff";